import { CatalogTable, CatalogTableRow } from '@backstage/plugin-catalog';
import { TableColumn } from '@backstage/core-components';
import { Entity } from '@backstage/catalog-model';
import { InfraStatusChip } from './InfraStatusChip';
import styles from './catalogStatus.module.css';

export const CREATED_AT_ANNOTATION = 'infrastructure.backstage.io/created-at';
export const EXPIRATION_DATE_ANNOTATION =
  'infrastructure.backstage.io/expiration-date';
export const INFRA_STATUS_ANNOTATION = 'infrastructure.backstage.io/status';
export const BUILD_STATUS_ANNOTATION =
  'infrastructure.backstage.io/build-status';

function formatCatalogDate(value?: string): string {
  if (!value || value === 'never') {
    return value === 'never' ? 'Never' : '-';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const createCreatedByColumn = (): TableColumn<CatalogTableRow> => ({
  title: 'Created By',
  field: 'entity.metadata.annotations',
  width: '12%',
  render: (row: CatalogTableRow) => {
    const entity = row.entity as Entity;
    const createdBy =
      entity.metadata.annotations?.['infrastructure.backstage.io/created-by'];
    return createdBy || '-';
  },
});

const createStatusColumn = (): TableColumn<CatalogTableRow> => ({
  title: 'Status',
  field: 'entity.metadata.annotations',
  width: '10%',
  render: (row: CatalogTableRow) => {
    const entity = row.entity as Entity;
    const annotations = entity.metadata.annotations ?? {};
    // Prefer stack/launch status; fall back to image build-status if present.
    const status =
      annotations[INFRA_STATUS_ANNOTATION] ||
      annotations[BUILD_STATUS_ANNOTATION];
    return <InfraStatusChip status={status} />;
  },
});

const createCreatedAtColumn = (): TableColumn<CatalogTableRow> => ({
  title: 'Created',
  field: 'entity.metadata.annotations',
  width: '14%',
  render: (row: CatalogTableRow) => {
    const entity = row.entity as Entity;
    const createdAt = entity.metadata.annotations?.[CREATED_AT_ANNOTATION];
    return (
      <span className={styles.dateText}>{formatCatalogDate(createdAt)}</span>
    );
  },
});

const createExpirationColumn = (): TableColumn<CatalogTableRow> => ({
  title: 'Destroy at',
  field: 'entity.metadata.annotations',
  width: '14%',
  render: (row: CatalogTableRow) => {
    const entity = row.entity as Entity;
    const expiration =
      entity.metadata.annotations?.[EXPIRATION_DATE_ANNOTATION];
    return (
      <span className={styles.dateText}>{formatCatalogDate(expiration)}</span>
    );
  },
});

/** Home / components catalog columns (excludes System, Owner, Type). */
export const customCatalogColumns = [
  CatalogTable.columns.createNameColumn({ defaultKind: 'Component' }),
  createStatusColumn(),
  createCreatedByColumn(),
  createCreatedAtColumn(),
  createExpirationColumn(),
  CatalogTable.columns.createMetadataDescriptionColumn(),
];
